import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import de from "../locales/de/translation.json";
import en from "../locales/en/translation.json";

const LANG_STORAGE_KEY = "msc-lang";

const savedLang = localStorage.getItem(LANG_STORAGE_KEY) ?? "de";

void i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
  },
  lng: savedLang,
  fallbackLng: "de",
  interpolation: {
    escapeValue: false, // React handles escaping
  },
});

// Persist language changes
i18n.on("languageChanged", (lng) => {
  localStorage.setItem(LANG_STORAGE_KEY, lng);
});

export { i18n, LANG_STORAGE_KEY };
